import axios from 'axios'
import baseService from './baseService.js'

const customerAssociationService = {
  list (customerId) {
    return new Promise((resolve, reject) => {
      axios
        .get('/customer/association/list?customerId=' + customerId, baseService.defaultConfig)
        .then(response => resolve(response.data))
        .catch(error => reject(error.response ? error.response.data : error))
    })
  },
  add (model) {
    return new Promise((resolve, reject) => {
      axios
        .post('/customer/association/add', model, baseService.defaultConfig)
        .then(response => resolve(response.data))
        .catch(error => reject(error.response ? error.response.data : error))
    })
  },
  remove (associationId) {
    return new Promise((resolve, reject) => {
      axios
        .post('/customer/association/remove?id=' + associationId, {}, baseService.defaultConfig)
        .then(response => resolve(response.data))
        .catch(error => reject(error.response ? error.response.data : error))
    })
  },
  changeType (associationId, type) {
    return new Promise((resolve, reject) => {
      axios
        .post('/customer/association/changeType?id=' + associationId + '&type=' + type, {}, baseService.defaultConfig)
        .then(response => resolve(response.data))
        .catch(error => reject(error.response ? error.response.data : error))
    })
  },
  updateNotes (associationId, notes) {
    return new Promise((resolve, reject) => {
      axios
        .post('/customer/association/updateNotes?id=' + associationId, JSON.stringify(notes), {
          ...baseService.defaultConfig,
          headers: { 'Content-Type': 'application/json' }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.response ? error.response.data : error))
    })
  }
}

export default customerAssociationService
